import React from 'react'
import Navbar from '../Navbar/Navbar'
import Slider from '../Slider/Slider'
import Services from '../Services/Services'
import About from '../About/About'
import Portfolio from '../Portfolio/Portfolio'
import Testimonials from '../Testimonial/Testimonial'
import Arrival from '../Arrival/Arrival'
import News from '../News/News'
import Connect from '../Connect/Connect'
import Footer from '../Footer/Footer'
import CategorySection from '../Category/CategorySection'
import ProductGrids from '../Products/Productgrids'
import Mask from '../Mask/Mask'
import Trend from '../Trend/Trend'
import Reach from '../Contact/Reach'
import Serve from '../Servicesmain/Serve'
import Award from '../Aboutus/Award'
import Count from '../Aboutus/Count'

const Home = () => {
  return (
    <>
     <CategorySection/>
      <Slider/>
      <Serve/>
      <Services/>
      <About/>
      <ProductGrids/>
      <Mask/>
      <Trend/>
      <Portfolio/>
      <Testimonials/>
      <Award/>
      <Count/>
      {/*-
      <Arrival/>
      -*/}
      <News/>
      <Connect/>
      <Reach/>
    
    </>
  )
}

export default Home